import { useMutation } from '@tanstack/react-query'
import { useRouter } from 'next/navigation'

import { axiosInstance } from '../axios'

export function Login() {
  const router = useRouter()
  const mutation = useMutation({
    mutationFn: ({ email, password }) =>
      axiosInstance.post('/login', { email, password }),
    onSuccess: async data => {
      const { token } = data
      router.push(`/api/auth?token=${token}`)
    },
  })
  return mutation
}

export function useGoogleLogin() {
  const router = useRouter()
  return useMutation({
    mutationFn: ({ redirectUrl }) =>
      axiosInstance.get('/google/login', { params: { redirectUrl } }),
    onSuccess: async data => {
      const { url } = data
      router.push(url)
    },
  })
}

export function Register() {
  return useMutation({
    mutationFn: ({ email, password, code, birthday }) =>
      axiosInstance.post('/register', { email, password, code, birthday }),
  })
}

export function RequestRegister() {
  return useMutation({
    mutationFn: ({ email }) => axiosInstance.post('/register/code', { email }),
  })
}

export function useRequestForgotPassword() {
  return useMutation({
    mutationFn: ({ email }) =>
      axiosInstance.post('/password/forget', { email }),
  })
}

export function useResetPassword() {
  return useMutation({
    mutationFn: ({ email, code, password, confirmPassword }) =>
      axiosInstance.patch('/password/reset', {
        email,
        code,
        password,
        confirmPassword,
      }),
  })
}
